import React from 'react';
import BackVideo from '../../components/BackVideo';
import SideLines from '../../components/Svg/side-lines';
import TopLines from '../../components/Svg/top-lines';
// import Bg from '../../assets/img/bg-map-main.png';
import Cases from "../../components/Cases";

export default (props) => {
    const {
        children,
        video,
        driverVideo,
        title,
        bg: Bg,
        driver,
        onEnded,
    } = props;

    return (
        <section className = { `page-section` }>
            <div className = 'hud hud-map'>
                <div className = 'hud__container-decor'>
                    <div className = 'hud__bg'>
                        {video && (
                            <div
                                className = 'hud__bg__video'
                                style = {{backgroundImage: 'url(' + Bg + ')'}}
                            >
                                <BackVideo
                                    video = { video }
                                />

                                {driver && driverVideo && (
                                    <BackVideo
                                        video = { driverVideo }
                                        onEnded = { onEnded }
                                        loop = { false }
                                    />
                                )}
                            </div>
                        )}
                        <div className = 'hud__bg__decor-top'/>
                        <div className = 'hud__bg__decor-bottom'/>
                    </div>

                    <div
                        className = 'hud__header'
                        style = {{height: '70px'}}>
                        <div className = 'hud__header__decor__container'>
                            <div className = 'hud__header__decor__row-1 hud__header__decor__row-center'>
                                <div className = 'hud__header__decor__item'>
                                    <TopLines />
                                </div>
                            </div>

                            <div className = 'hud__header__decor__row-2 hud__header__decor__row-space-between'>
                                <div className = 'hud__header__decor__item'>
                                    <SideLines />
                                </div>

                                <div className = 'hud__header__decor__item hud__header__decor__item-reverse'>
                                    <SideLines />
                                </div>
                            </div>
                        </div>

                        {title && (
                            <div className = 'hud__header__title'>
                                {title}
                            </div>
                        )}

                        <Cases/>
                    </div>

                    <div
                        className = 'hud__footer'
                        style = {{height: '50px'}}
                    >
                        <div className = 'hud__footer__decor__container'>
                            <div className = 'hud__footer__decor__row-1 hud__footer__decor__row-center'>
                                <div className = 'hud__footer__decor__item'>
                                    <TopLines />
                                </div>
                            </div>

                            <div className = 'hud__footer__decor__row-2 hud__footer__decor__row-space-between'>
                                <div className = 'hud__footer__decor__item'>
                                    <SideLines />
                                </div>

                                <div className = 'hud__footer__decor__item hud__footer__decor__item-reverse'>
                                    <SideLines />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {children}
            </div>
        </section>
    );
};
